import { put, call, take, fork } from 'redux-saga/effects'
import { cardMediaAddService } from '../../api/card'
//import { questionMediaAddSuccess } from '../../reducers/question/action'
import { cardMediaAddSuccess } from '../../reducers/card/action'
import { CARD_MEDIA_ADD } from '../../reducers/card/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* cardMediaAddFlow(payload) {
  try {
    const { entity, callback } = payload
    const response = yield call(cardMediaAddService, entity)
    yield put(cardMediaAddSuccess(response.data))
    yield put(operationSuccess())

    callback()
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* cardMediaAddWatcher() {
  while (true) {
    const action = yield take(CARD_MEDIA_ADD)
    const { payload } = action

    yield fork(generalSaga, cardMediaAddFlow, payload)
  }
}
